import { Theme } from "src/app/shared/models/theme";
let theme = new Theme();
theme.name = 'MobileApp';
theme.addStyleDependency('ionic-css', 'https://cdn.jsdelivr.net/npm/@ionic/core@7.0.14/css/ionic.bundle.css');
theme.addScriptDependency('ionic-script', 'https://cdn.jsdelivr.net/npm/@ionic/core@7.0.14/dist/ionic/ionic.js');
theme.addFontDependency('ionic-font', 'Roboto');
theme.addStyleDependency('swiper-css', 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css');

export const ionicTheme = theme;